import React from 'react';

const DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
const IconContext = React.createContext && React.createContext(DefaultContext);

export { DefaultContext, IconContext };
